"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _index = _interopRequireDefault(require("./index"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tableContext = require("./Context/tableContext");
var _LocaleContext = require("../locales/LocaleContext");
var _default2 = _interopRequireDefault(require("../locales/default"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var EditableTableV3 = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var containerRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    providerMounted = _useState2[0],
    setProviderMounted = _useState2[1];
  var handleEditingStatusChange = (0, _react.useCallback)(function (editingKey, selectedDataIndex) {
    if (props.mode === 'cell' && !props.editOnFocus) {
      if (editingKey === '' && selectedDataIndex === null) {
        if (containerRef !== null && containerRef !== void 0 && containerRef.current && _tableContext.eventHub.getState('submitingElementClassName')) {
          // https://stackoverflow.com/questions/497094/how-do-i-find-out-which-dom-element-has-the-focus
          // if nothnig is focused we can focus back to classNamed element

          if (!(document.hasFocus() && document.activeElement !== null && document.activeElement !== document.body && document.activeElement !== document.documentElement)) {
            var elements = containerRef.current.getElementsByClassName(_tableContext.eventHub.getState('submitingElementClassName'));
            if (elements && elements[0] && elements[0].focus) {
              var _elements$;
              (_elements$ = elements[0]) === null || _elements$ === void 0 ? void 0 : _elements$.focus();
            }
          }
        }
      }
    }
  }, [containerRef.current]);
  (0, _react.useEffect)(function () {
    var unsubscriber = [_tableContext.eventHub.on('update.editingKey&selectedDataIndex', handleEditingStatusChange)];
    setProviderMounted(true);
    return function () {
      unsubscriber.forEach(function (fn) {
        return fn();
      });
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: containerRef
  }, /*#__PURE__*/_react.default.createElement(_LocaleContext.LocaleReceiver, {
    component: "Table",
    defaultLocale: _default2.default.Table
  }, function (localeCode, locale) {
    return /*#__PURE__*/_react.default.createElement(_tableContext.TableProvider, (0, _extends2.default)({
      ref: ref
    }, props, {
      localeCode: localeCode,
      locale: locale
    }), providerMounted && /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
      type: "editable"
    }, props)));
  }));
});
EditableTableV3.defaultProps = {
  data: [],
  focusedHighlight: false,
  className: '',
  size: 'default',
  loading: false,
  bordered: true,
  indentSize: 20,
  rowKey: 'key',
  showHeader: true,
  sortDirections: ['ascend', 'descend'],
  zebra: false,
  expandable: null,
  rowSelection: null,
  editOnFocus: true,
  mode: 'cell'
};
EditableTableV3.propTypes = {
  columns: _propTypes.default.array.isRequired,
  data: _propTypes.default.array.isRequired,
  mapValuesFromForm: _propTypes.default.func.isRequired,
  mapValuesToForm: _propTypes.default.func.isRequired,
  mode: _propTypes.default.oneOf(['cell', 'row']),
  focusedHighlight: _propTypes.default.bool,
  className: _propTypes.default.string,
  size: _propTypes.default.string,
  loading: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.object]),
  bordered: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  sortDirections: _propTypes.default.array,
  zebra: _propTypes.default.bool,
  rowKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  theme: _propTypes.default.object,
  onResize: _propTypes.default.func,
  prefixCls: _propTypes.default.string,
  defaultSorting: _propTypes.default.array,
  // [{ desc: false, id: "dataIndex" }]
  onSortingChange: _propTypes.default.func,
  onColumnFiltersChange: _propTypes.default.func,
  emptyText: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),
  scroll: _propTypes.default.shape({
    x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    y: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
  }),
  rowSelection: _propTypes.default.oneOfType([_propTypes.default.shape({
    type: _propTypes.default.oneOf(['checkbox', 'radio']),
    enableRowSelection: _propTypes.default.bool,
    selectedRowKeys: _propTypes.default.object,
    onChange: _propTypes.default.func,
    hideDefaultSelections: _propTypes.default.bool,
    selections: _propTypes.default.array,
    checkStrictly: _propTypes.default.bool,
    fixed: _propTypes.default.bool
  }), _propTypes.default.bool]),
  expandable: _propTypes.default.oneOfType([_propTypes.default.shape({
    expandedRowKeys: _propTypes.default.object,
    defaultExpandedRowKeys: _propTypes.default.object,
    expandedRowRender: _propTypes.default.func,
    expandRowByClick: _propTypes.default.bool,
    expandIcon: _propTypes.default.func,
    onExpand: _propTypes.default.func,
    onExpandedRowsChange: _propTypes.default.func,
    defaultExpandAllRows: _propTypes.default.bool,
    indentSize: _propTypes.default.number,
    expandIconColumnIndex: _propTypes.default.number,
    expandedRowClassName: _propTypes.default.func,
    childrenColumnName: _propTypes.default.string
  }), _propTypes.default.bool]),
  pagination: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
    disabled: _propTypes.default.bool,
    current: _propTypes.default.number,
    defaultCurrent: _propTypes.default.number,
    total: _propTypes.default.number,
    pageSize: _propTypes.default.number,
    defaultPageSize: _propTypes.default.number,
    showTotal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func])
  })]),
  virtualSettings: _propTypes.default.shape({
    overscan: _propTypes.default.number
  })
};
var _default = exports.default = EditableTableV3; // export default forwardRef((props, ref) => (
//   <EditableTableV3 ref={ref} {...props} />
// ));